import React, { FC, HTMLAttributes, FormEvent } from 'react'
import classNames from 'classnames'

interface IAddEntityFormProps extends HTMLAttributes<HTMLFormElement> {
  dataTest?: string
}

export const AddEntityForm: FC<IAddEntityFormProps> = ({
  children,
  className,
  dataTest,
  onSubmit,
}) => {
  const classes = classNames('add-entity-form', className)

  /**
   * This function prevents submit events from bubbling up to
   * parent form elements. This matters if this
   * form is nested inside another form.
   */
  const submitHandler = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    e.stopPropagation()
    if (onSubmit) {
      onSubmit(e)
    }
  }

  return (
    <form onSubmit={submitHandler} className={classes} data-test={dataTest}>
      {children}
    </form>
  )
}

interface IAddEntityFormFooterProps extends HTMLAttributes<HTMLDivElement> {
  dataTest?: string
}

export const AddEntityFormFooter: FC<IAddEntityFormFooterProps> = ({
  children,
  className,
  dataTest,
}) => {
  const classes = classNames('add-entity-form-footer', className)
  return (
    <div className={classes} data-test={dataTest}>
      {children}
    </div>
  )
}
